import { render, staticRenderFns } from "./SearchItemsProductListWithInspirations.vue?vue&type=template&id=0a6e9308&"
import script from "./SearchItemsProductListWithInspirations.vue?vue&type=script&lang=js&"
export * from "./SearchItemsProductListWithInspirations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports